import { rgba } from 'polished';
import { css } from 'styled-components';
import { combineValues, globalTheme } from '@clds/component-theme';
import { focusVisible } from './focusVisible.js';
export const focusRingShadow = css `0 0 0 3px ${combineValues(globalTheme.palette.primary, (color) => rgba(color, 0.5))}`;
const focusRingTransition = 'box-shadow 250ms';
// eslint-disable-next-line @typescript-eslint/ban-types
const focusRingCommon = (otherTransition) => otherTransition
    ? css `
        outline: none;
        transition: ${focusRingTransition}, ${otherTransition};
      `
    : css `
        outline: none;
        transition: ${focusRingTransition};
      `;
const noFocusRingShadow = '0 0 0 0 transparent';
// eslint-disable-next-line @typescript-eslint/ban-types
export const focusRing = (otherBoxShadow, otherTransition) => otherBoxShadow
    ? css `
        ${focusRingCommon(otherTransition)};
        box-shadow: ${noFocusRingShadow}, ${otherBoxShadow};

        &${focusVisible()} {
          box-shadow: ${focusRingShadow}, ${otherBoxShadow};
        }
      `
    : css `
        ${focusRingCommon(otherTransition)};
        box-shadow: ${noFocusRingShadow};

        &${focusVisible()} {
          box-shadow: ${focusRingShadow};
        }
      `;
export const insetFocusRing = () => css `
  ${focusRingCommon()};

  &${focusVisible()} {
    // Solution to have box shadow above content
    // https://stackoverflow.com/questions/13188828/inset-box-shadow-beneath-content
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-shadow: inset ${focusRingShadow};
      pointer-events: none;
    }
  }
`;
//# sourceMappingURL=focusRing.js.map